import { AuthenticationClient } from 'entio-sdk';

const { REACT_APP_API_AUTHENTICATION_URL } = process.env;
const getAuthenticationClient = () => {
    return new AuthenticationClient({ appId: 'fashadmin', baseUrl: REACT_APP_API_AUTHENTICATION_URL });
};

export default getAuthenticationClient;
